import * as React from "react";
import * as cls from "./FileUpload.module.scss";
export default function FileUpload({
  inputRef,
  id,
  label,
  required,
  disabled,
  autoComplete,
  checked,
  onChange,
  className,
}) {
  function handleFileChange(event) {
    if (event.target.files[0]) {
      const fileExtension = event.target.files[0].name
        .split(".")
        .pop()
        .toLowerCase();
      if (!FileUpload.accept.includes(fileExtension)) {
        const errorEvent = new ErrorEvent("error", {
          error: {
            error_type: "other",
            errors: [
              "Недопустимый формат файла.",
              "Пожалуйста, загрузите файл в формате PDF или PNG.",
            ],
            http_error: 400,
          },
        });
        window.dispatchEvent(errorEvent);
        return;
      }
      onChange(event);
    }
  }

  return (
    <div className={className}>
      {label ? <label className={cls.textLabel}>{label}</label> : undefined}
      <input
        ref={inputRef}
        id={id}
        name={id}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        // value={uncontrolled ? undefined : value ?? ""}
        onChange={handleFileChange}
        className={cls.inputHidden}
        type="file"
        accept={"." + FileUpload.accept.join(", .")}
      />
      <label className={cls.inputLabel} htmlFor={id}>
        {/* {el.uploaded_files[0]?.filename ? "Загрузить еще" : "Загрузить"} */}
        {checked ? "✔ Загружено" : "Загрузить"}
      </label>
    </div>
  );
}
/** Список поддерживаемых расширений файлов. */
FileUpload.accept =
  [
    "bmp",
    "doc",
    "docx",
    "mp3",
    "ods",
    "odt",
    "ogg",
    "pdf",
    "png",
    "rtf",
    "txt",
    "wav",
    "xls",
    "xlsx",
  ];
